canopyPublic.controller("DepotController", ["$scope", "LumaPublicAPI", "$stateParams", function ($scope, LumaPublicAPI, $stateParams) {

	const shareExpiredMessage = "Oops! This share has expired.",
		noAccessMessage = "Oops! You no longer have access to this share.",
		noShareIdMessage = "Oops! No share ID specified.";

	var init = function () {
		$scope.share = null;
		$scope.error = null;
		$scope.paths = Luma.paths;
		$scope.guestUUID = $stateParams.guestUUID;
		
		if ($stateParams && $stateParams.guestUUID) {
			$scope.guestUUID = $stateParams.guestUUID;
			loadShare();
		}
		else {
			$scope.error = noShareIdMessage;
		}
	};

	var loadShare = function () {
		LumaPublicAPI.getShareStatus($stateParams.guestUUID).then(function (successResponse) {
			if (successResponse.data) {
				if (successResponse.data.status === "Available") {
					$scope.share = successResponse.data;
					loadShareAssets();
				} else {
					switch (successResponse.data.status) {
						case "Unfound":
							$scope.error = noAccessMessage;
							break;

						default:
							$scope.error = shareExpiredMessage;
					}
				}
			}
		}, function (errorResponse) {
			$scope.error = shareExpiredMessage;
		});
	};

	var loadShareAssets = function () {
		var onSuccess = function (successResponse) {
			$scope.share.assets = successResponse.data;
		};

		var onError = function (errorResponse) {
			$scope.error = shareExpiredMessage;
		};

		LumaPublicAPI.listPublicShareAssets($stateParams.guestUUID).then(onSuccess, onError);
	};
	
	$scope.onGetDownloadAllOptions = function () {				
		LumaPublicAPI.getShareDerivativeMenu($scope.guestUUID).then(function (response) {
			if (response.data.length) {
				$scope.downloadAllOptions = response.data;
			} else {
				window.location.href = $scope.paths.context + "/servlet/download/com.intrepia.luma.ShrinkWrapShare?guestUUID=" + $scope.guestUUID;
			}
		});
	};
	$scope.onDownloadAll = function (option) {
		window.location.href =
			$scope.paths.context +
			"/servlet/interface/com.intrepia.luma.ShrinkWrapShareDerivatives" +
			"?guestUUID=" + $scope.guestUUID +
			"&transformIDs=" + option.id.toString();
	};
	
	$scope.onGetDownloadAssetOptions = function (asset) {
		LumaPublicAPI.getPublicShareAssetDerivativeMenu($scope.guestUUID, [ asset.id ].toString()).then(function (response) {
			if (response.data.length) {
				asset.downloadOptions = response.data;
			} else {
				window.location.href = $scope.paths.context + "/servlet/download/com.intrepia.luma.DownloadSharedAsset?assetID=" + asset.id + "&guestUUID=" + $scope.guestUUID;
			}
		});
	};

	$scope.onDownloadAsset = function (asset, transform) {
		window.location.href =
			$scope.paths.context +
			"/servlet/interface/com.intrepia.luma.ShrinkWrapSharedAssetDerivatives" +
			"?assetIDs=" + asset.id.toString() +
			"&guestUUID=" + $scope.guestUUID +
			"&transformIDs=" + transform.id.toString();
	};

	init();
}]);